import Grid from '@sport1/react-elements/Grid'
import React, { FunctionComponent } from 'react'
import Label from '../../../Theme/Fonts/Label'

type Props = {
    data?: string
}

const OptionalField: FunctionComponent<Props> = ({ data }) =>
    data ? (
        <Grid marginTop={1} noExpand>
            <Label textAlign="center" color="keshi-3" lineHeight="13px">
                {data}
            </Label>
        </Grid>
    ) : null

export default OptionalField
